import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { Subject, Observable } from 'rxjs';
import { YetiSocket } from '../yeti-socket';
import { environment } from 'src/environments/environment';
import { IMessage } from 'src/app/interface/message';
import { StringHelper } from 'src/app/helper/string/string-helper';

@Injectable({
	providedIn: 'root'
})
export class MessageSentService {

	private echo: Echo<any>;

	constructor() {
		this.echo = YetiSocket.connect();
	}

	public listener(data?: IMessageSent): Observable<IMessageSentResponse> {
		if (!data?.type || !data.id) {
			return new Observable();
		}
		const subject = new Subject<IMessageSentResponse>();
		const channelEvent = environment.socketChannel;
		const listenEvent = StringHelper.sprintf('.message_sent_%s_%d', data.type, data.id);
		this.echo
			.channel(channelEvent)
			.listen(listenEvent, (response :any) => subject.next(response));
		return subject.asObservable();
	}
}

interface IMessageSent {
	id?: number;
	type?: string;
}

interface IMessageSentResponse {
	message?: IMessage;
}
